import React from 'react';
import { FaUser } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { clsx } from '../../utils/utils';
import * as styles from './ClientPortalButton.module.scss';

export interface ClientPortalButtonProps {
  headerWithOpaqueBackground?: boolean;
  isMobile?: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
  className?: string;
}

// The Client Portal "Coming Soon" pages are the client's self-contained static
// HTML files served from site/static/ (not Gatsby-managed pages), so we link to
// them with a plain anchor that does a full page load and opens in a new tab.
// There is one file per language; we pick the right one from the current site
// language.
const CLIENT_PORTAL_URLS: Record<string, string> = {
  pt: '/area-cliente.html',
  en: '/client-portal.html',
};

const ClientPortalButton = ({
  headerWithOpaqueBackground,
  isMobile,
  onClick,
  className,
}: ClientPortalButtonProps): React.ReactElement => {
  const { i18n, t } = useTranslation();

  const url = CLIENT_PORTAL_URLS[i18n.language] || CLIENT_PORTAL_URLS.pt;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      className={clsx(
        styles.link,
        isMobile && styles.mobile,
        headerWithOpaqueBackground && styles.headerWithOpaqueBackground,
        className,
      )}
    >
      <FaUser className={styles.icon} aria-hidden="true" />
      <span>{t('clientPortalButton.title', 'Área Cliente')}</span>
    </a>
  );
};

export default ClientPortalButton;
